import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** EmbedUrl property - Definition */
export class DocsBlockEmbedUrlPropertyDefinition extends DocsBlockPropertyDefinition {
}
